import produce from 'immer';
import {
    OEM_MAKE_LIST, OEM_MAKE_LIST_REQUESTING, USER_OEM_LIST,
    USER_OEM_LIST_REQUESTING, OEM_UNKNOWN_DEVICE, OEM_UNKNOWN_DEVICE_REQUESTING
} from "../constants/action-types";


const initialState = {
    makeList: {
        isRequesting: false,
        payload: [],
    },
    userOEM: {
        isRequesting: false,
        payload: [],
    },
    unknownDevices: {
        isRequesting: false,
        payload: [],
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case OEM_MAKE_LIST:
            state = produce(state, s => {
                s.makeList.isRequesting = false;
                s.makeList.payload = action.payload ? action.payload : [];
            });
            break;
        case OEM_MAKE_LIST_REQUESTING:
            state = produce(state, s => {
                s.makeList.isRequesting = true;
                s.makeList.payload = [];
            });
            break;
        case OEM_UNKNOWN_DEVICE:
            state = produce(state, s => {
                s.unknownDevices.isRequesting = false;
                s.unknownDevices.payload = action.payload ? action.payload : [];
            });
            break;
        case OEM_UNKNOWN_DEVICE_REQUESTING:
            state = produce(state, s => {
                s.unknownDevices.isRequesting = true;
                s.unknownDevices.payload = [];
            });
            break;
        case USER_OEM_LIST:
            state = produce(state, s => {
                s.userOEM.isRequesting = false;
                s.userOEM.payload = action.payload ? action.payload : [];
            });
            break;
        case USER_OEM_LIST_REQUESTING:
            state = produce(state, s => {
                s.userOEM.isRequesting = true;
                s.userOEM.payload = [];
            });
            break;
        default:
            break;
    }
    return state;
}